module.exports = __webpack_public_path__ + "img/icaycc.04bedb68.png";